<template>
  <div>
    <section class="container-fluid p-0 bodyArea">
      <div class="containerBox">
        <div class="pageHeader row m-0 align-items-center" v-if="$auth.isAuthenticated">
          <div class="col-3 p-0 pageHeaderTitle">Release Notes</div>
          <div class="col text-right p-0">
            <div>
              <ReleaseNavBar @myEvent="fetchData" />
            </div>
          </div>
        </div>
      </div>
      <div class="pageDataWrapper pageActualDataWrapper">
        <div class="align-items-center mb-3">
          <div class="filterWrapper">
            <div class="filterText">Tenant:</div>
            <model-select v-model="lastSelectedTenantObj" :options="tenants" name="text" id="value"
              placeholder="Select Tenant" @input="validateSelection" class="tenatList">
            </model-select>
            <!-- <select
                style="background: transparent; color: #fff;  border: 0;"
                id="tenantId"
                v-model="lastSelectedTenant"
                @change="fetchData"
            >
              <option
                  class="tenantOption"
                  v-for="option in tenants"
                  v-bind:key="option.value"
                  :value="option.value"
              >{{ option.text ? option.text : option.value }}
              </option>
            </select> -->
          </div>
          <!--          <div class="col">-->
          <!--            <Datepicker-->
          <!--                v-model="value"-->
          <!--                placeholder="Date"-->
          <!--                @change="onDateChange()"-->
          <!--            >-->
          <!--            </Datepicker>-->
          <!--          </div>-->
          <!--          <div v-if="value != '' && lastSelectedTenant != '*'" class="col">-->
          <!--            <b-button class="actionBtn clientShowBtn" @click.prevent="fetchData">Search</b-button>-->
          <!--          </div>-->
        </div>
        <div class="contentHeader row m-0 align-items-center">
          <div class="col">Date</div>
          <div class="col">Target</div>
          <div class="col">Type</div>
          <div class="col flex-10">Description</div>
        </div>

        <div v-if="list.length > 0" class="contentDataWrap">
          <div v-for="item in list" v-bind:key="item.id">
            <div class="contentDataWrapper actions contentActualDataWrapper row m-0">
              <div class="contentData row m-0 align-items-center col-12 p-0">
                <div class="col">{{ item.date }}</div>
                <div class="col">
                  {{ item.target }}
                </div>
                <div class="col">{{ item.type }}</div>
                <div class="col flex-10" v-bind:title="item.description">
                  {{ item.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="listEmpty == true">
          <h3>No results found</h3>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import ReleaseNavBar from "../components/ReleaseNavBar.vue";
import Datepicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import 'vue-search-select/dist/VueSearchSelect.css'
import { ModelSelect } from 'vue-search-select'

export default {
  name: "ReleaseNotes",
  components: {
    ReleaseNavBar,
    Datepicker,
    ModelSelect,
  },
  data() {
    return {
      list: "",
      tenantsList: [],
      value: "",
      dateValue: "",
      lastSelectedTenant: "*",
      lastSelectedTenantObj: "*",
      tenants: [{ text: "-SELECT ALL-", value: "*" }],
      listEmpty: false,
    };
  },
  async mounted() {
    console.log('mounted - release notes');
    await this.fetchTenants();
    await this.fetchData();
    $("input").attr("autocomplete", "off");
  },
  methods: {
    onDateChange() {
      this.dateValue = this.value.format("YYYY-MM-DD");
    },
    async fetchTenants() {
      console.log('fetchTenants')
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var tenants_list_request = new Request(
        config.TENET_SERVICE + "/tenants/?list=true",
        {
          method: "GET",
          mode: "cors",
          cache: "default",
          withCredentials: true,
          credentials: "include",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        }
      );
      try {
        var tenants_list = await fetch(tenants_list_request);
        if (tenants_list && tenants_list.status == 503) {
          return this.fetchTenants();
        } else if (tenants_list.status === 200) {
          var response = await tenants_list.json();
          this.tenants = response
            .map((t) => {
              return {
                text: t.text || t.value,
                id: t.value,
                value: t.value.toLowerCase().replace('-', ''),
              };
            })
            .sort((a, b) => {
              return a.text.localeCompare(b.text);
            });
          this.tenants.forEach((e) =>
            this.tenantsList.push({ value: e.value, text: e.text || e.value })
          );
        }
      } catch (error) {
        console.error(error);
      }
    },
    getDropdownValues(tenant) {
      return this.tenantsList.filter((e) => e.value == tenant || e.text == tenant);
    },
    getTenantId(Obj) {
      let objVal = this.tenants.find(e => e.value == Obj);
      if (objVal) {
        return objVal.id
      }
      else {
        return ""
      }
    },
    validateSelection() {
      this.lastSelectedTenant = this.getTenantId(this.lastSelectedTenantObj);
      this.fetchData();
    },
    async fetchData() {
      this.listEmpty = false;
      this.list = [];
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      if (this.dateValue == "") {
        this.dateValue = new Date().toISOString().split("T")[0];
      }
      var Url =
        config.TENET_SERVICE +
        `/tenants/${this.lastSelectedTenant}/release-notes?date=${this.dateValue}&limit=100&offset=0`;
      try {
        const res = await fetch(Url, {
          method: "GET",
          mode: "cors",
          withCredentials: true,
          cache: "default",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        });
        if (res.status == 503) {
          return this.fetchTenants();
        } else {
          const newRes = await res.json();

          this.list = newRes.items;
          if (this.list.length == 0) {
            this.listEmpty = true;
          } else if (this.list.length > 0) {
            this.listEmpty = false;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../style.scss";

.pageHeader {
  font-family: GTWalsheimPro-Regular !important;
  font-size: 15px;
  font-weight: 400;
}

.pageActualDataWrapper {
  max-height: 100%;
}

.contentDataWrapper {
  font-family: GTWalsheimPro-Regular !important;

  font-size: 16px;
  //overflow-y: auto;
  overflow-x: hidden;
  font-weight: 400;
}

.contentDataWrapper.actions {
  overflow: initial !important;
}

.contentDataWrapper.actions .contentData>div.dropdownAction {
  overflow: initial !important;
}

.contentDataWrap {
  // max-height: calc( 100vh - 160px );;
  //max-height: calc( 100vh - 100px );
  height: 100%;
  overflow-y: auto;
  padding-bottom: 20px;
}

.flex-10 {
  flex: 10 !important;
}

.contentHeader {
  font-family: GTWalsheimPro-Regular !important;
  font-size: 16px;
  overflow-x: hidden;
  font-weight: 400;
  overflow: inherit;
}


.filterWrapper {
  background: #575757;
  display: inline-flex;
  padding: 0px 10px;
  font-size: 15px;

  min-width: 420px;
  max-width: 420px;
  border-radius: 5px;
  margin-left: 0px;
  margin-right:10px;
  //max-width: 250px;
  line-height: 36px;
  text-overflow: ellipsis;
}

.filterHeader .filterWrapper {
  border: 1px solid #ebebeb;
  background: #fff;
}

.pageActualDataWrapper .filterWrapper{
  background: #fff;
    border: 1px solid #ebebeb;
}
.pageActualDataWrapper ::v-deep .ui.search.dropdown .text {
    color: #6a6a6a;
}


.ui.selection.dropdown.tenantList .text{
  color: #fff;
}

.dropdown {
  cursor: pointer;
  background: transparent !important;
  border: 0px;
}

.filterWrapper .dropdown {
  top: auto !important;
}

.filterText {
  color: #6a6a6a;
  opacity: 1;
  padding-right: 0px;
  padding-top: 0px !important;
}

::v-deep .contentHeader > div {
    border-left: 1px solid #c7c7c7;
    display: inline-flex;
}

.filterWrapper .dropdown:before {
  content: "";
  border: solid #8e8e8e;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  right: 0px;
  top: 15px;
}


.ui.selection.dropdown {
  border: none !important;
  box-shadow: none !important;

  i.dropdown.icon {
    display: none;
  }
}

  ::v-deep .ui.search.dropdown .text{
    color:#fff;
  }


.tenantOption {
  color: #6a6a6a;
  padding: 10px;
}

.actionBtn.clientShowBtn.btn-secondary {
  border-radius: 5px;
  min-width: 80px;
  text-align: center !important;
  display: inline-grid;
  background: #00b5da;
  color: #fff;
  line-height: 40px;
  padding: 0 15px;
  cursor: pointer;
  font-size: 16px;
  border-color: #00b5da;
}

.actionBtn.clientShowBtn.btn-secondary:hover {
  background: #1dd8f6;
  color: #ffffff;
  border-color: #1dd8f6;
}

// .col:first-child {
//   border-right: 1px solid #c7c7c7;
//   padding-right: 20px;
// }

textarea.form-control {
  box-shadow: none;
  background: transparent;
  outline: none !important;
  border: 1px solid #dceaea;
  border-radius: 5px;
  width: 100%;
  padding: 7px 15px;
  color: #6a6a6a;
}

.text-right {
  text-align: left !important;
}


::v-deep .ui.selection.dropdown .menu .item{
  overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    // max-width: 334px;
    margin: 0px 10px 2px;
    padding: 10px 7px !important;
    border-radius: 5px;
    border: none;
}

.pageHeader  ::v-deep .ui.default.dropdown:not(.button)>input:focus~.text, .pageHeader  ::v-deep .ui.dropdown:not(.button)>input:focus~.default.text,.pageHeader ::v-deep .ui.active.search.dropdown input.search:focus+.text{
  color:#fff !important;
}

::v-deep .ui.selection.active.dropdown .menu {
  border: 1px solid #EBEBEB;
  box-shadow: 0 2px 3px 0 rgba(34, 36, 38, .15);
  padding: 10px 0;
  margin-top: 1px;
  border-top-width: 1px !important;
}


::v-deep .ui.selection.active.dropdown:hover,::v-deep .ui.selection.active.dropdown{
  box-shadow:none;
}

::v-deep .ui.dropdown .menu>.item:hover{
  color:#1dd8f6;
  background:#EAF9FF !important;
}
::v-deep .ui.dropdown .menu>.item.selected{
  color:#1dd8f6;
  background:#fff;
}

</style>
